import { render, staticRenderFns } from "./choiceDot.vue?vue&type=template&id=2cd5ea14&"
import script from "./choiceDot.vue?vue&type=script&lang=js&"
export * from "./choiceDot.vue?vue&type=script&lang=js&"
import style0 from "./choiceDot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd5ea14')) {
      api.createRecord('2cd5ea14', component.options)
    } else {
      api.reload('2cd5ea14', component.options)
    }
    module.hot.accept("./choiceDot.vue?vue&type=template&id=2cd5ea14&", function () {
      api.rerender('2cd5ea14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/choiceDot.vue"
export default component.exports